
import React from "react";
import NavBarComponent from "../../components/navBar/NavBarComponent";
import FooterComponent from "../../components/home/FooterComponent";
import OrderStatusComponent from "../../components/checkout/orderStatusComponent";


export default function OrderStatusPage() {

    return (
        <div>
            <NavBarComponent />
            <OrderStatusComponent />
            <FooterComponent />
        </div>
    )
}